import { render, staticRenderFns } from "./IndexMenu.vue?vue&type=template&id=a15b15e0&scoped=true&"
import script from "./IndexMenu.vue?vue&type=script&lang=js&"
export * from "./IndexMenu.vue?vue&type=script&lang=js&"
import style0 from "./IndexMenu.vue?vue&type=style&index=0&id=a15b15e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15b15e0",
  null
  
)

export default component.exports